import React from 'react';
import SubSpecialties from './sub_specialties';
import { type SubSpecialtiesProps } from './sub_specialties';
import Specialties from './specialties';
import { type SpecialtiesProps } from './specialties';

interface CompanyProfileProps {
  allBrokerSpecialties: SpecialtiesProps['allBrokerSpecialties'];
  allSubSpecialties: SubSpecialtiesProps['allSubSpecialties'];
  companySpecialties: SpecialtiesProps['companySpecialties'];
  companySubSpecialties: SubSpecialtiesProps['companySubSpecialties'];
}

export default function CompanyProfile({
  allBrokerSpecialties,
  allSubSpecialties,
  companySpecialties,
  companySubSpecialties,
}: CompanyProfileProps) {
  return (
    <>
      <hr/>
      <Specialties
        allBrokerSpecialties={allBrokerSpecialties}
        companySpecialties={companySpecialties}
      />
      <SubSpecialties
        allSubSpecialties={allSubSpecialties}
        companySubSpecialties={companySubSpecialties}
      />
    </>
  );
}
